import styled from 'styled-components'
import { Image, Modal, Skeleton } from '@sketch/components'

export const StyledModal = styled(Modal)`
  position: relative;
`

export const BlurredLogoContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow: hidden;
  z-index: -1;

  ::before,
  ::after {
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  ::before {
    background: rgba(85, 93, 255, 0.04);
  }

  ::after {
    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 73%);
  }
`

export const BlurredLogo = styled(Image)`
  width: 100%;
  height: 100px;

  & img {
    object-fit: cover;
    filter: blur(48px);
    object-position: center 40%;
  }

  ::before,
  ::after {
    content: '';
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
  }

  ::before {
    background-color: rgba(255, 255, 255, 0.38);
  }

  ::after {
    background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0),
      rgba(255, 255, 255, 0.31)
    );
  }
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 24px;
`

export const IconWrapper = styled.div<{ $isSkeleton?: boolean }>`
  flex-shrink: 0;
  border-radius: ${({ theme }) => theme.radii.xxlarge};
  overflow: hidden;
  ${({ $isSkeleton, theme }) =>
    !$isSkeleton && `border: 1px solid ${theme.colors.border.A};`}
`

export const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`

export const IntegrationTitle = styled.h1`
  font-size: ${({ theme }) => theme.fontSizes.G};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  margin: 0;
`

export const Section = styled.div`
  margin-bottom: 24px;

  &:last-child {
    margin-bottom: 0;
  }
`

export const SectionTitle = styled.h3`
  margin: 16px 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.F};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
`

export const SectionContent = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const InfoTable = styled.table`
  width: 100%;
`

export const InfoLabel = styled.td`
  font-size: ${({ theme }) => theme.fontSizes.D};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
  padding: 8px 0;
  width: auto;
`

export const InfoValue = styled.td`
  font-size: ${({ theme }) => theme.fontSizes.D};
  color: ${({ theme }) => theme.colors.foreground.secondary.B};
  padding: 8px 0;
  padding-left: 16px;
`

// Skeleton components
export const SkeletonIcon = styled(Skeleton)`
  border-radius: ${({ theme }) => theme.radii.large};
`

export const SkeletonTitle = styled(Skeleton)`
  margin-bottom: 4px;
`

export const SkeletonSectionTitle = styled(Skeleton)`
  margin: 16px 0 4px 0;
`
